import { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";
import TutorModel from "../../../api/models/TutorModel";
import CandidateCalendar from "../../candidate-calendar/CandidateCalendar";
import CandidateTutorsTable from "../../candidate-tutors-table/CandidateTutorsTable";
import Modal from "../ModalWithFooter";
import useFilterable from "../../../hooks/useFilterable";
import { useAuth } from "../../../context/AuthContext";

type BookSessionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedDate: Moment | null;
  onSelectDate: (date: Moment | null) => void;
  selectedTime: Moment | null;
  onSelectTime: (time: Moment | null) => void;
  tutorsList: TutorModel[];
  selectedTutor: TutorModel | null;
  onSelectTutor: (tutor: TutorModel | null) => void;
  onBookSession: () => void;
  amHoursList: {
    dateTime: moment.Moment;
    isDisabled: boolean;
  }[];
  pmHoursList: {
    dateTime: moment.Moment;
    isDisabled: boolean;
  }[];
  dates: {
    date: moment.Moment;
    isDisabled: boolean;
  }[];
};
export default function BookSessionModal(props: BookSessionModalProps) {
  const {
    isOpen,
    onClose,
    selectedDate,
    onSelectDate,
    selectedTime,
    onSelectTime,
    tutorsList,
    selectedTutor,
    onSelectTutor,
    onBookSession,
    amHoursList,
    pmHoursList,
    dates,
  } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.bookSession",
  });
  const { currentUser }: any = useAuth();

  return (
    <Modal open={isOpen} setOpen={onClose}>
      <Modal.Body setOpen={onClose} title={t("title")}>
        <CandidateCalendar
          selectedDate={selectedDate}
          onSelectDate={onSelectDate}
          selectedTime={selectedTime}
          onSelectTime={onSelectTime}
          amHoursList={amHoursList}
          pmHoursList={pmHoursList}
          dates={dates}
        />
        <div className="font-medium text-sm text-gray-700 mt-6 mb-2">
          {t("selectTutor")}
        </div>
        <CandidateTutorsTable
          tutors={tutorsList ?? []}
          selectedTutor={selectedTutor}
          onSelectTutor={onSelectTutor}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
          onClick={() => onClose()}
        >
          {t("cancel")}
        </button>
        <button
          type="button"
          disabled={!selectedDate || !selectedTime || !selectedTutor}
          className="mx-4 inline-flex justify-center rounded-md border border-transparent disabled:bg-gray-600 bg-brandblue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
          onClick={onBookSession}
        >
          {t("confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
